module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Whoever does not miss the Soviet Union has no heart. Whoever wants it back has no brain.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Vladimir Putin")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Beware: Some liars tell the truth!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Ancient Arab proverb")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e77b2a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c7.vue
// module id = 72
// module chunks = 0